export default __webpack_public_path__ + "static/section_10-a7d884b97fe624bf81971208430d136b.jpeg";